import React from "react";
import "./Sidebar.scss";
import { CiLocationOn } from "react-icons/ci";
import { RxPerson } from "react-icons/rx";
import { MdOutlineCategory } from 'react-icons/md';
import { HiOutlineDocumentText, HiOutlineUsers } from "react-icons/hi";
import NavigationItem from "./NavigationItem";
import { FaFileAlt } from 'react-icons/fa'; // Fa for Font Awesome

const SidebarContent = () => (
  <div className="h-full w-full text-left flex flex-col items-center pt-10 pr-4 ">
    <NavigationItem icon={<CiLocationOn />} title={"Branch"} path="/dashboard/branches" />
    <NavigationItem icon={<RxPerson />} title={"Roles"} path="/dashboard/roles" />
    <NavigationItem icon={<HiOutlineDocumentText />} title={"Forms"} path="/dashboard/forms" />
    <NavigationItem icon={<MdOutlineCategory />} title={"Categories"} path="/dashboard/form-categories" />
    <NavigationItem icon={<HiOutlineUsers />} title={"Users"} path="/dashboard/users" />
  </div>
);

const SideBar = ({ isOpen = false, onClose = () => {} }) => {
  return (
    <>
      {/* Desktop rail */}
      <aside className="hidden xl:flex xl:w-[250px] h-[100vh] border-r bg-white ">
        <SidebarContent />
      </aside>

      {/* Mobile drawer + overlay */}
      {/* Overlay */}
      {isOpen && (
        <div
          onClick={onClose}
          className="fixed inset-0 z-40 bg-black/40 backdrop-blur-sm xl:hidden"
          aria-hidden="true"
        />
      )}

      {/* Drawer panel */}
      <aside
        className={`fixed inset-y-0 left-0 z-50 w-72 bg-white shadow-lg transform transition-transform duration-300 xl:hidden ${
          isOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
        role="dialog"
        aria-modal="true"
        aria-label="Sidebar"
      >
        {/* Optional close header for mobile */}
        <div className="h-14 px-4 border-b flex items-center justify-between">
          <span className="font-semibold">Menu</span>
          <button
            className="p-2 rounded-md hover:bg-gray-100 focus:outline-none focus:ring focus:ring-blue-300"
            onClick={onClose}
            aria-label="Close menu"
          >
            ✕
          </button>
        </div>
        <div className="h-[calc(100%-56px)] overflow-y-auto">
          <SidebarContent />
        </div>
      </aside>
    </>
  );
};

export default SideBar;
